import { render, staticRenderFns } from "./PlenaryProgram.vue?vue&type=template&id=68004d6c&scoped=true&"
import script from "./PlenaryProgram.vue?vue&type=script&lang=js&"
export * from "./PlenaryProgram.vue?vue&type=script&lang=js&"
import style0 from "./PlenaryProgram.vue?vue&type=style&index=0&id=68004d6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68004d6c",
  null
  
)

export default component.exports